import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[appTestId]',
    standalone: false
})
export class TestIdDirective {
  @Input()
  set appTestId(testId: string) {
    this.el.nativeElement.setAttribute('data-test-selector', testId);
    this.el.nativeElement.setAttribute('data-testid', testId);
  }

  constructor(private el: ElementRef<HTMLElement>) {}
}
